module.exports=function(scope){ return `# create faceMap with base64 image
curl -X POST \
'https://api.zoomauth.com/api/v2/biometrics/create-facemap-from-single-image' \
-H 'X-Device-License-Key: ${scope.appToken}' \
-H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)' \
-H 'content-type: application/json' \
-d '{
  "image": INSERT_IMAGE_DATA_AS_BASE64_HERE,
  "sessionId": INSERT_SESSION_ID_HERE
}'

# create faceMap with image file
curl -X POST \
'https://api.zoomauth.com/api/v2/biometrics/create-facemap-from-single-image' \
-H 'X-Device-License-Key: ${scope.appToken}' \
-H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)' \
-H 'content-type: multipart/form-data;' \
-F 'image=@/path_to_image/my_image.jpg' \
-F 'sessionId=INSERT_SESSION_ID_HERE'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/facemap-post.bash.tpl